import { render, staticRenderFns } from "./ShowCarousel.vue?vue&type=template&id=0857d9ad&scoped=true&"
import script from "./ShowCarousel.vue?vue&type=script&lang=js&"
export * from "./ShowCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ShowCarousel.vue?vue&type=style&index=0&id=0857d9ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0857d9ad",
  null
  
)

export default component.exports